import React, { Component } from 'react';
import './style.css';


const ClassicText = (props) => {
    //const marked = require('marked')
    function createMarkup() {
        return {
            __html: props.classictext
        }
    }

    return (
        <div className='classictext-contain'>
    <div className='classictext' dangerouslySetInnerHTML={createMarkup()} /> </div>
       
    );
}

export default ClassicText


// WEBPACK FOOTER //
// ./src/components/ClassicText.js